import {Outlet} from "react-router-dom";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
export const MaterialRequestOutlet = () => <Outlet />;
